import 'react'
import { styled } from '@mui/system'
import i18n from '../../utils/i18n'
import appleLoginLogo from '../images/appleLoginLogo.svg';
import googleLoginLogo from '../images/googleLoginLogo.svg';
import emailLoginLogo from '../images/emailLoginLogo.png';


const SignInButton = styled('div')(
  ({ theme }) => ({
    background: '#4285F4',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '19px',
    display: 'flex',
    alignItems: 'center',
    color: '#FFFFFF',
    cursor: 'pointer',
    borderRadius: 8,
    padding: '4.5px 0 5.5px 4px',

    '&:hover': {
      filter: 'brightness(105%)'
    }
  }),
);

const SignInButtonIcon = styled('span')(
  ({ theme }) => ({
    width: 44,
    height: 44,
    marginRight: '38px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: '44px auto',
    flex: 'none',
  }),
);

const SignInButtonText = styled('p')(
  ({ theme }) => ({
    margin: 0,
    '&.es': {
      fontSize: 12
    },
    '&.pt': {
      fontSize: 12
    },
  }),
);

export default function SignInBtn(props: { type: 'email' | 'apple' | 'google' | 'anonymous', style?: React.CSSProperties }) {
  const { type, style } = props;
  switch (type) {
    case 'anonymous':
      return (
        <SignInButton style={{ backgroundColor: "#C7C7C7", ...style }}>
          <SignInButtonIcon></SignInButtonIcon>
          <SignInButtonText className={i18n.language}>Continue with Guest</SignInButtonText>
        </SignInButton>
      );
    case 'email':
      return (
        <SignInButton style={{ backgroundColor: "#FD9728", ...style }}>
          <SignInButtonIcon
            style={{
              backgroundImage: `url(${emailLoginLogo})`,
              backgroundSize: 'initial',
            }}
          ></SignInButtonIcon>
          <SignInButtonText className={i18n.language}>{i18n.t('sign_in_with_email')}</SignInButtonText>
        </SignInButton>
      );
    case 'apple':
      return (
        <SignInButton style={{ backgroundColor: 'black', ...style }}>
          <SignInButtonIcon
            style={{
              backgroundImage: `url(${appleLoginLogo})`,
              backgroundSize: '44px auto',
              borderRight: 'none',
              marginRight: '42px'
            }}
          ></SignInButtonIcon>
          <SignInButtonText className={i18n.language}>{i18n.t('sign_in_with_apple')}</SignInButtonText>
        </SignInButton>
      );
    case 'google':
      return <SignInButton style={style}>
        <SignInButtonIcon style={{ backgroundImage: `url(${googleLoginLogo})` }} />
        <SignInButtonText className={i18n.language}>{i18n.t("sign_in_with_google")}</SignInButtonText>
      </SignInButton>;
    default:
      return null;
  }
}
